import { DownOutlined, UploadOutlined, UpOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  InputNumber,
  notification,
  Radio,
  Row,
  Select,
  Upload,
} from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import classes from "./EtapeDonneesGeneralesFNH.module.css";
import { useContext, useEffect, useState } from "react";
import {
  deleteDocumentAffaire,
  getListFormateursByUser,
  uploadDocumentAffaire,
} from "../../../../api/geoprod";
import { useLoader } from "../../../../context/LoaderContext";
import GlobalContext from "../../../../context/GlobalContext";
import axiosInstance from "../../../../utils/axios";
const { Panel } = Collapse;

const EtapeDonneesGeneralesFNH = ({
  form,
  typesession,
  id_session_formation,
  copieDossierFileList,
  setCopieDossierFileList,
  globalData,
  setGlobalData,
  dataFormationNonHomloguee
}) => {
  const { t } = useTranslation();
  const { setIsLoading } = useLoader();
  const [formateurs, setFormateurs] = useState([]);
  const { gouvernoratOptions } = useContext(GlobalContext);
const [annexes, setAnnexes] = useState([]);
 const [showAnnexeFields, setShowAnnexeFields] = useState(false);
  const expandIcon = ({ isActive }) =>
    isActive ? <UpOutlined /> : <DownOutlined />;

  const { Option } = Select;
  const fetchContractData = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(
        `${import.meta.env.VITE_APP_GEOPROD_API}/v1/get_contrat_affaire/${
          JSON.parse(sessionStorage.getItem("globalData"))?.id_affaire_parent
        }`,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      );
  

          if (response?.data?.contrat?.affaire_fils?.length > 0) {
        const annexOptions = response?.data?.contrat?.affaire_fils?.map((annex, index) => ({
          label: `Annexe ${index + 1}`,
          value: index,
          address: annex?.establishment_data_address
        }));
        
        setAnnexes(annexOptions);
        setShowAnnexeFields(true);
      } else {
        notification.warning({
          message: t("Erreur"),
          description: t("Aucun lieu annexe n’est disponible. Vous avez sélectionné un lieu de formation annexe, mais votre établissement ne possède actuellement aucun site annexe déclaré. Veuillez modifier votre choix ou mettre à jour vos informations."),
          duration: 0,
        });
        setShowAnnexeFields(false);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
        try {
            setIsLoading(true);
          const response = await getListFormateursByUser();
          const formattedFormateurs = response?.data?.data?.map(item => ({
            value: item.id,
            label: `${item.nom} ${item.prenom}`,
          }));
          setFormateurs(formattedFormateurs);
           const x = {
             ...JSON.parse(sessionStorage.getItem("globalData")),
             ...globalData,
          all_trainers: formattedFormateurs,
        };

        sessionStorage.setItem("globalData", JSON.stringify(x));
        setGlobalData(x);


          setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            setFormateurs([]);

        notification.error({
          message: t("Erreur"),
          description:
            error?.response?.data?.message ||
            "Une interruption est survenue lors de la récupération des données. Veuillez réessayer.",
          duration: 0,
        });
      }
    };

    fetchData();
  }, []);

  const handlePreview = async (file) => {
    window.open(file.url, "_blank");
  };


const removeFile = async () => {
  const id_affaire = typesession === "non_homologuee"
    ? sessionStorage.getItem("id_session_formation_non_homologuee")
    : sessionStorage.getItem("id_session_formation_continue");

  const fileUrl = copieDossierFileList[0]?.url;
  
  if (fileUrl) {
    
    setIsLoading(true);
    await deleteDocumentAffaire(id_affaire, fileUrl).then(()=>{

     setCopieDossierFileList([]); 
  
      form.setFieldsValue({
          ...form.getFieldsValue(),
        copie_programme_formation: undefined,
      });
         setIsLoading(false);

      }).catch((error)=>{
      setIsLoading(false);
     notification.error({
      message: t("Erreur"),
      description: t(error?.data?.message),
      duration: 0,
    });
      })
    } 
  //  else {
  //   setCopieDossierFileList([]); 
  //   form.setFieldsValue({
  //     ...form.getFieldsValue(),
  //     copie_programme_formation: undefined,
  //   });
  // }
};

  const uploadFile = async (file, key) => {
    const id_affaire =
      typesession === "non_homologuee"
        ? sessionStorage.getItem("id_session_formation_non_homologuee")
        : sessionStorage.getItem("id_session_formation_continue");
    setIsLoading(true);
    const formData = new FormData();
    formData.append("id_affaire", id_affaire);
    formData.append("id_type_doc", import.meta.env.VITE_APP_ID_TYPE_DOC);
    formData.append("name_doc", file?.file?.name);
    formData.append("file[]", file?.file);
    formData.append("key", key);

    try {
      const response = await uploadDocumentAffaire(formData);
      if (response?.data?.path) {
        
        const uploadedFile = {
          uid: file?.file?.uid,
          name: file?.file?.name,
          status: "done",
          url: response?.data?.path,
        };

        setCopieDossierFileList([uploadedFile]);
         form.setFieldsValue({
      ...form.getFieldsValue(),
     copie_programme_formation: [uploadedFile],
    });
       
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
        setCopieDossierFileList([]); 
  
      form.setFieldsValue({
          ...form.getFieldsValue(),
        copie_programme_formation: undefined,
      });
      notification.error({
        message: "Erreur",
        description:
          error?.response?.data?.message ||
          "Une erreur est survenue lors du téléversement du fichier. Veuillez réessayer.",
        duration: 0,
      });
    }
  };
  return (
    <div>
      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        expandIcon={expandIcon}
        expandIconPosition="end"
        className={classes.container}
      >
        <Panel
          header={
            <div className={classes.headerStyle}>
              <span>
                Informations par défaut de la session
                <span style={{ marginLeft: "0.5rem" }}></span>
              </span>
            </div>
          }
          key="1"
        >
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item label={t("Secteur")} name="secteur">
                <Input disabled />
              </Form.Item>
            </Col>
              <Col xs={24} sm={12}>
                <Form.Item label={t("Sous-secteur")} name="sous_secteur">
                  <Input disabled />
                </Form.Item>
              </Col>

            <Col xs={24} sm={12}>
              <Form.Item label={t("Domaine")} name="domaine">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
        </Panel>
      </Collapse>

      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        expandIcon={expandIcon}
        expandIconPosition="end"
        className={classes.container}
      >
        <Panel
          header={
            <div className={classes.headerStyle}>
              <span>
                Données à configurer pour la session
                <span style={{ marginLeft: "0.5rem" }}></span>
              </span>
            </div>
          }
          key="1"
        >
          <Row gutter={16}>
           
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Date de début de la session de formation")}
                name="date_debut_session_formation"
                rules={[
                  { required: true, message: t("Veuillez remplir ce champ.") },
                ]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder="JJ/MM/AAAA"
                  style={{ width: "100%" }}
                  disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                  disabledDate={(current) =>
                    current && current < dayjs().add(1, "month").startOf("day")
                  }
                  onCalendarChange={() => {
                    
                    form.setFieldsValue({
                      ...form.getFieldsValue(),
                      date_fin_session_formation: "",
                    });
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Date de fin de la session de formation")}
                name="date_fin_session_formation"
                rules={[
                  { required: true, message: t("Veuillez remplir ce champ.") },
                ]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder="JJ/MM/AAAA"
                  disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    const dateDebut = form.getFieldValue(
                      "date_debut_session_formation"
                    );
                    return (
                      current &&
                      (!dateDebut || current < dayjs(dateDebut).add(1, "day"))
                    );
                  }}
                />
              </Form.Item>
            </Col>
  <Col xs={24} sm={12}>
              <Form.Item
                label={t("Durée en heures")}
                name="duree_heures"
                rules={[
                          {
                            required: true,
                            message: t("Veuillez remplir ce champ."),
                          },
                          {
                            validator: (_, value) => {
                              if (value === undefined || value === null || value === "") {
                                return Promise.resolve(); 
                              }
                              if (value < 1) {
                                return Promise.reject(new Error(t("La durée doit être au minimum de 1 heure.")));
                              }
                              return Promise.resolve();
                            },
                          },
      ]}
              >
                 <InputNumber
                    disabled={id_session_formation  && sessionStorage.getItem("consulter") === "true"}
                    style={{ width: "100%" }}
                  />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Lieu de la formation")}
                name="lieu_formation"
                rules={[
                  { required: true, message: t("Veuillez remplir ce champ.") },
                ]}
              >
                <Select
                  disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                  onChange={(value) => {
                    
                    if (value === "EPF") {
                      form.setFieldsValue({
                        ...form.getFieldsValue(),
                        gouvernorat: JSON.parse(
                          sessionStorage.getItem("globalData")
                        )?.gouvernorat || dataFormationNonHomloguee?.establishment_data_governorate,
                        adresse_epf:JSON.parse(
                          sessionStorage.getItem("globalData")
                        )?.adresse_epf || dataFormationNonHomloguee?.establishment_data_address,
                        liste_annexe: undefined,
                        adresse_annexe: "",
                      });
                     setShowAnnexeFields(false);
                    } 
                     else if (value === "Annexe") {
                         fetchContractData();
                     form.setFieldsValue({
                        ...form.getFieldsValue(),
                        gouvernorat: "",
                        adresse_epf: "",
                      });
                    }
                    else {
                      form.setFieldsValue({
                        ...form.getFieldsValue(),
                         gouvernorat: "",
                        adresse_epf: "",
                        liste_annexe: undefined,
                        adresse_annexe: "",
                      });
                      setShowAnnexeFields(false);
                    }
                  }}
                >
                  {typesession === "continue" && (
                    <>
                      <Option value="EPF">EPF</Option>
                      <Option value="autre_lieu">Autre lieu</Option>
                    </>
                  )}
                  {typesession === "non_homologuee" && (
                    <>
                      <Option value="EPF">EPF</Option>
                      <Option value="Annexe">Annexe</Option>
                    </>
                  )}
                </Select>
              </Form.Item>
            </Col>
            {typesession === "continue" ? (
  <Form.Item
    noStyle
    shouldUpdate={(prev, next) => prev.lieu_formation !== next.lieu_formation}
  >
    {({ getFieldValue }) => {
      const lieu = getFieldValue("lieu_formation");

      if (lieu === "autre_lieu") {
        return (
          <>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Lieu")}
                name="autre_lieu_formation"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Input placeholder="" disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Adresse")}
                name="adresse_autre_lieu"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Input placeholder="" disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Gouvernorat")}
                name="gouvernorat"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Select
                  disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                  optionFilterProp="label"
                  showSearch
                  options={gouvernoratOptions}
                />
              </Form.Item>
            </Col>
          </>
        );
      }

      if (lieu === "EPF") {
        return (
          <>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Adresse")}
                name="adresse_epf"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Input placeholder="" disabled={ true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Gouvernorat")}
                name="gouvernorat"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Select
                  disabled={ true}
                  optionFilterProp="label"
                  showSearch
                  options={gouvernoratOptions}
                />
              </Form.Item>
            </Col>
          </>
        );
      }

      return null;
    }}
  </Form.Item>
) : (
  <Form.Item
    noStyle
    shouldUpdate={(prev, next) => prev.lieu_formation !== next.lieu_formation}
  >
    {({ getFieldValue }) => {
      const lieu = getFieldValue("lieu_formation");

      if (lieu === "EPF") {
        return (
          <>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Adresse")}
                name="adresse_epf"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Input placeholder="" disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Gouvernorat")}
                name="gouvernorat"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Select
                  disabled={true}
                  optionFilterProp="label"
                  showSearch
                  options={gouvernoratOptions}
                />
              </Form.Item>
            </Col>
          </>
        );
      }
if (lieu === "Annexe" && showAnnexeFields) {
      return (
        <>
          <Col xs={24} sm={12}>
            <Form.Item
              label={t("Liste des annexes")}
              name="liste_annexe"
              rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
            >
             <Select
                              disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                              optionFilterProp="label"
                              showSearch
                              onChange={(value) => {
                                // Set the address when an annex is selected
                                const selectedAnnex = annexes.find(
                                  (annex) => annex.value === value
                                );
                                form.setFieldsValue({
                                  ...form.getFieldsValue(),
                                  adresse_annexe: selectedAnnex?.address,
                                });
                              }}
                            >
                              {annexes.map((annex) => (
                                <Option key={annex.value} value={annex.value}>
                                  {annex.label}
                                </Option>
                              ))}
                            </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label={t("Adresse de l'annexe")}
              name="adresse_annexe"
              rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
            >
              <Input placeholder="" disabled={true } />
            </Form.Item>
          </Col>
        </>
      );}
       return null;
    }}
  </Form.Item>
)}

            {/* {typesession === "continue" ?  (
              <Form.Item
                noStyle
                shouldUpdate={(prev, next) =>
                  prev.lieu_formation !== next.lieu_formation
                }
              >
                {({ getFieldValue }) =>
                  getFieldValue("lieu_formation") === "autre_lieu" ? (
                    <>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label={t("Lieu")}
                        name="autre_lieu_formation"
                        rules={[
                          {
                            required: true,
                            message: t("Veuillez remplir ce champ."),
                          },
                        ]}
                      >
                        <Input
                          placeholder=""
                          disabled={id_session_formation}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label={t("Adresse")}
                        name="adresse_autre_lieu"
                        rules={[
                          {
                            required: true,
                            message: t("Veuillez remplir ce champ."),
                          },
                        ]}
                      >
              <Input
                          placeholder=""
                          disabled={id_session_formation}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                       <Form.Item
                  label={t("Gouvernorat")}
                  name="gouvernorat"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select
                    disabled={id_session_formation}
                    optionFilterProp="label"
                    showSearch
                    options={gouvernoratOptions}
                  />
                </Form.Item> </Col>
                </>
                  )   getFieldValue("lieu_formation") === "EPF" ?  
                  (


                       <>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label={t("Adresse")}
                        name="adresse_epf"
                        rules={[
                          {
                            required: true,
                            message: t("Veuillez remplir ce champ."),
                          },
                        ]}
                      >
              <Input
                          placeholder=""
                          disabled={id_session_formation || true}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                       <Form.Item
                  label={t("Gouvernorat")}
                  name="gouvernorat"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select
                    disabled={id_session_formation || true}
                    optionFilterProp="label"
                    showSearch
                    options={gouvernoratOptions}
                  />
                </Form.Item> </Col>
                </>


                  ) : null

                }
              </Form.Item>
            ): 
            (   <Form.Item
                noStyle
                shouldUpdate={(prev, next) =>
                  prev.lieu_formation !== next.lieu_formation
                }
              >
                {({ getFieldValue }) =>
                  getFieldValue("lieu_formation") === "EPF" ? (
                    <>
                      <Col xs={24} sm={12}>
                      <Form.Item
                        label={t("Adresse")}
                        name="adresse_epf"
                        rules={[
                          {
                            required: true,
                            message: t("Veuillez remplir ce champ."),
                          },
                        ]}
                      >
              <Input
                          placeholder=""
                          disabled={id_session_formation || true}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                       <Form.Item
                  label={t("Gouvernorat")}
                  name="gouvernorat"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select
                    disabled={id_session_formation || true}
                    optionFilterProp="label"
                    showSearch
                    options={gouvernoratOptions}
                  />
                </Form.Item> </Col>
                </>
                  ) : 
                  (


                       <>
               
                    <Col xs={24} sm={12}>
                  <Form.Item
                  label={t("Liste des annexes")}
                  name="liste_annexe"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select
                    disabled={id_session_formation}
                    optionFilterProp="label"
                    showSearch
                    options={gouvernoratOptions}
                  />
                </Form.Item> </Col>
                     <Col xs={24} sm={12}>
                      <Form.Item
                        label={t("Adresse de l'annexe")}
                        name="adresse_annexe"
                        rules={[
                          {
                            required: true,
                            message: t("Veuillez remplir ce champ."),
                          },
                        ]}
                      >
                  <Input
                          placeholder=""
                          disabled={id_session_formation}
                        />
                      </Form.Item>
                    </Col>
                </>


                  )

                }
              </Form.Item>)
          } */}

            {/* {typesession === "continue" && (
              <Col xs={24} sm={12}>
                <Form.Item
                  label={t("Gouvernorat")}
                  name="gouvernorat"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select
                    disabled={id_session_formation}
                    optionFilterProp="label"
                    showSearch
                    options={gouvernoratOptions}
                  />
                </Form.Item>
              </Col>
            )} */}

            {typesession === "continue" && (
              <Col xs={24} sm={12}>
                <Form.Item
                  label={t("Droit de tirage")}
                  name="droit_tirage"
               
                 rules={[
                      {
                        required: false,
                        message: t("Veuillez remplir ce champ."),
                      },
                      {
                        validator: (_, value) => {
                       if (value === undefined || value === null || value === "") {
                            return Promise.resolve();
                          }
                          if (value < 1) {
                            return Promise.reject(new Error(t("La valeur doit être supérieure à 1.")));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                >
                  <InputNumber
                    disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                    style={{ width: "100%" }}
                    // min={1}
                  />
                </Form.Item>
              </Col>
            )}

            {typesession === "continue" && (
              <Col xs={24} sm={12}>
                <Form.Item
                  label={t("Crédit d'impôt")}
                  name="credit_impot"

                      rules={[
                      {
                        required: false,
                        message: t("Veuillez remplir ce champ."),
                      },
                      {
                        validator: (_, value) => {
                       if (value === undefined || value === null || value === "") {
                            return Promise.resolve();
                          }
                          if (value < 1) {
                            return Promise.reject(new Error(t("La valeur doit être supérieure à 1.")));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}

                 
                >
                  <InputNumber
                    disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Formateurs")}
                name="formateurs"
                rules={[
                  { required: true, message: t("Veuillez remplir ce champ.") },
                ]}
              >
                <Select
                  mode="multiple"
                  options={formateurs}
                  disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                ></Select>
              </Form.Item>
            </Col>

            {/* <Col xs={24} sm={12}>
              <Form.Item
                label={t("Nombre des participants")}
                name="nb_apprenants"
                rules={[
                  { required: true, message: t("Veuillez remplir ce champ.") },
                ]}
              >
                <InputNumber disabled={id_session_formation}
                 
                  style={{ width: "100%" }}
                  min={1}
                />
              </Form.Item>
            </Col> */}

            <Col xs={24} sm={12}>
              <Form.Item
                label="Copie programme formation"
                name="copie_programme_formation"
                rules={[
                  {
                    required: true,
                    message: t("Veuillez téléverser un fichier."),
                  },
                ]}
              >

                <Upload
                  fileList={copieDossierFileList}
                  onPreview={handlePreview}
                    onChange={({ fileList }) => {
    
                    setCopieDossierFileList(fileList);
                    if (fileList.length === 0) {
                      form.setFieldsValue({ ...form.getFieldsValue(),copie_programme_formation: undefined });

                    }
                  }}
                  onRemove={() => removeFile()}
                  customRequest={(options) =>
                    uploadFile(options, "copie_programme_formation")
                  }
                    // beforeUpload={() => false}
                  showUploadList={{
                    showPreviewIcon: true,
                    showRemoveIcon: !id_session_formation,
                  }}
                  disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                >
                  <Button
                    disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                    icon={<UploadOutlined />}
                  >
                    Copie programme formation
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </div>
  );
};

export default EtapeDonneesGeneralesFNH;
